import { createContext } from 'react';

import { SourceMediaTracks } from 'features/source-media-tracks/services';

export const SourceMediaTracksContext = createContext<{
  service: SourceMediaTracks;
}>({
  service: SourceMediaTracks.getInstance(),
});
